var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"checked-label"},[_c('FontAwesomeIcon',{attrs:{"icon":"fa-check check-icon"}}),_c('span',{staticClass:"label-text"},[_vm._v(_vm._s(_vm.text))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }